module.exports = __webpack_public_path__ + "img/meet_logo_dark.9d3cfbb2.png";